<template>
  <editor v-model="myValue" :id="tinymceId" :api-key="apiKey" :init="init" />
</template>

<script>
import Editor from '@tinymce/tinymce-vue'
import ossUploadFile from '@/utils/ossUploadFile'
import { generateUUID, replaceALiUrl } from '@/utils/util.js';
export default {
  name: "my-tiny",
  components: {
    'editor': Editor
  },
  props: {
    id: {
      type: String,
      default: function () {
        return `vue-tinymce-${new Date().getTime()}${(Math.random() * 1000).toFixed(0)}`
      }
    },
    value: {
      type: String,
      default: ''
    },
    height: {
      type: [Number, String],
      required: false,
      default: 700
    },
    width: {
      type: [Number, String],
      required: false,
      default: 'auto'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      apiKey: 'inbxhfdot77a3zj53o6hlsm4e11su9ci9aqvye8cqj61cje0',
      tinymceId: this.id,
      // 配置文件服务器的静态访问路径前缀
      // static_web_preurl: 'http://localhost/files/hxzy_img/',
      // 初始化配置
      init: {
        selector: `#${this.id}`,
        content_style: "p {margin: 0; border:0; padding: 0;}",
        // language_url: '/tinymce/langs/zh_CN.js',
        language: 'zh_CN',
        // skin_url: '/tinymce/skins/ui/oxide',
        height: this.height,
        body_class: 'panel-body ',
        object_resizing: true,//是否允许调整图像大小.
        branding: false, //隐藏右下角由TINY驱动
        contextmenu_never_use_native: true, //防止浏览器上下文菜单出现在编辑器中
        elementpath: false, //隐藏底栏的元素路径（隐藏右下角元素显示）
        toolbar: [
          'formatselect fontsizeinput fontselect fontsizeselect insert styleselec | undo redo removeformat | bold italic underline strikethrough superscript subscript backcolor forecolor | numlist bullist | table | searchreplace fullscreen',
          'alignleft aligncenter alignright alignjustify lineheight outdent indent | link unlink image media | preview code',
        ],
        menubar: false,
        plugins: ' paste lists link anchor code wordcount image table visualchars visualblocks searchreplace preview pagebreak nonbreaking media insertdatetime fullscreen directionality autosave autolink advlist ',
        font_formats: "微软雅黑='微软雅黑';宋体='宋体';黑体='黑体';仿宋='仿宋';楷体='楷体';隶书='隶书';幼圆='幼圆';Andale Mono=andale mono,times;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;Comic Sans MS=comic sans ms,sans-serif;Courier New=courier new,courier;Georgia=georgia,palatino;Helvetica=helvetica;Impact=impact,chicago;Symbol=symbol;Tahoma=tahoma,arial,helvetica,sans-serif;Terminal=terminal,monaco;Times New Roman=times new roman,times;Trebuchet MS=trebuchet ms,geneva;Verdana=verdana,geneva;Webdings=webdings;Wingdings=wingdings", //字体
        font_size_formats: '9px 10px 11px 12px 14px 16px 18px 20px 22px 24px 26px 28px 36px 42px 48px 72px',
        // 配置工具栏时添加的 fontsizeinput 工具可以展示一个可输入字号的组件，默认单位是pt，现改为px
        font_size_input_default_unit: 'px',
        paste_retain_style_properties: 'all', //从Word中复制，保留所有样式
        paste_enable_default_filters: false, // 修改为 false 以允许保留图片标签
        paste_word_valid_elements: 'img[*], *[*]', // 允许保留图片标签及其他元素
        paste_data_images: true, // 粘贴的同时能把内容里的图片自动上传，非常强力的功能
        paste_convert_word_fake_lists: false, // 设为false可禁用复制word中的列表内容时，转换为html的UL或OL格式。
        paste_webkit_styles: 'all',
        paste_merge_formats: true, //启用PowerPaste插件的合并格式功能，例如：<b>abc <b>bold</b> 123</b>成为<b>abc bold 123</b>
        end_container_on_empty_block: true, //如果在空的内部块元素中按下Enter键，则可以使用此选项拆分当前容器块元素。
        // powerpaste_word_import: 'clean', //保留标题，表格和列表等内容的结构，但删除内联样式和类。这样就产生了使用站点CSS样式表的简单内容，同时保留了原始文档的语义结构。
        advlist_bullet_styles: 'default,circle,disc,square',
        advlist_number_styles: 'default,lower-alpha,lower-greek,lower-roman,upper-alpha,upper-roman',
        default_link_target: '_blank', //默认链接是当前窗口打开，你也可以通过此参数将其变为_blank新窗口打开。
        link_title: false,
        nonbreaking_force_tab: true, // 按tab键插入三个&nbsp;。一直按一直插。
        // images_upload_handler: this.images_upload_handler, //该images_upload_handler选项允许你指定被用来替代TinyMCE的默认的JavaScript和定制逻辑上传处理函数的函数。
        convert_urls: false,
        file_picker_types: 'file media',
        file_picker_callback: (cb, value, meta) => {
          let input = document.createElement('input');
          input.setAttribute('type', 'file');
          let _this = this;
          input.onchange = function () {
            let file = this.files[0]; //只选取第一个文件。如果要选取全部，后面注意做修改
            let name = file.name
            let path = _this.handleUploadPath(name)
            ossUploadFile.uploadFile(file, path, function (res) {
              cb(replaceALiUrl(res.res.name), {
                title: name
              })
            })
          }
          input.click();
        },
        urlconverter_callback: function (url, node, on_save, name) {
          console.log(url, node, on_save, name)
          if (node === 'img' && url.startsWith('blob:') || url.startsWith('data:') || url.startsWith('file:')) {
            tinymce.activeEditor && tinymce.activeEditor.uploadImages()
            console.log(url, node, on_save, name)
          }
          return url;
        },
        // 此处为图片上传处理函数 该方法为工具栏上传图片 需要走后台上传接口 与上面的方法区分开
        // images_upload_handler: (blobInfo) => new Promise((resolve, reject) => {
        //   // debugger // 移除或保留用于调试
        //   let base64 = 'data:image/jpeg;base64,' + blobInfo.base64();
        //   let name = blobInfo.filename();
        //   let path = this.handleUploadPath(name);
        //   ossUploadFile.uploadBase64File(base64, path, name, function (res) {
        //     if (res && res.res && res.res.name) {
        //       console.log(replaceALiUrl(res.res.name));
        //       resolve(replaceALiUrl(res.res.name));
        //     } else {
        //       reject('上传失败'); // 处理上传失败的情况
        //     }
        //   });
        // }),
        images_upload_handler: (blobInfo, success, failure) => {
          let base64 = 'data:image/jpeg;base64,' + blobInfo.base64();
          let name = blobInfo.filename()
          let path = this.handleUploadPath(name)
          ossUploadFile.uploadBase64File(base64, path, name, function (res) {
            success(replaceALiUrl(res.res.name))
          })
        },
        setup: (editor) => {
          let self = this;
          editor.on('paste', (e) => {
            self.handlePaste(e)
          })
          editor.on('init', function (e) {
            this.setContent(self.value)
            this.getBody().style.fontSize = '14pt';
            this.getBody().style.fontFamily = '微软雅黑';
          });
          editor.on('change', function (e) {
            self.$emit('input', e.target.getContent())
          })

        },
        content: this.value
      },
      myValue: this.value,
    }
  },
  watch: {
    value(newValue) {
      this.myValue = newValue
    },
    myValue(newValue) {
      // this.$emit('input', newValue)
    }
  },
  mounted() {
  
    ossUploadFile.getSTSToken();
  },
  methods: {
    handlePaste(e) {
      console.log('paste', e)

      const clipdata = e.clipboardData || window.clipboardData;

      const content = clipdata.getData('text/html');
      const parser = new DOMParser();
      // 解析 HTML 字符串为文档
      const doc = parser.parseFromString(content, 'text/html');

      const imgElements = doc.querySelectorAll('img');

      if (!imgElements.length || Array.from(imgElements).map(img => img.src).every(src => src.startsWith('http'))) {
        return false;
      }

      // 提取 src 属性
      const altSources = Array.from(imgElements).map(img => getFileNameFromPath(img.src));
      // console.log(altSources, 'altSources')

      let rtf = clipdata.getData('text/rtf');

      // let imageElements = findAllImageElementsWithLocalSource();
      let imagesHexSources = extractImageDataFromRtf(rtf);

      const uploadPromises = []; // 新增：用于存储上传的 Promise

      for (let i = 0; i < imagesHexSources.length; i++) {
        const base64 = `data:${imagesHexSources[i].type};base64,${_convertHexToBase64(imagesHexSources[i].hex)}`;
        const name = imagesHexSources[i].alt;
        const path = this.handleUploadPath(name);

        // 修改：将上传操作的 Promise 存储到数组中
        uploadPromises.push(new Promise((resolve) => {
          ossUploadFile.uploadBase64File(base64, path, name, function (res) {
            if (res && res.res && res.res.name) {
              imagesHexSources[i].netSrc = replaceALiUrl(res.res.name);
              resolve(); // 上传成功时解析 Promise
            } else {
              resolve(); // 上传失败时也解析 Promise
            }
          });
        }));
      }

      // 修改：在所有上传完成后再调用 updateImageSources
      Promise.all(uploadPromises).then(() => {
        updateImageSources(this.id, imagesHexSources);
      });


      function updateImageSources(tinymceId, newSrcArray) {
        const editor = tinymce.get(tinymceId);
        if (editor) {
          const content = editor.getContent();
          const doc = parser.parseFromString(content, 'text/html');
          const imgElements = doc.querySelectorAll('img');

          imgElements.forEach((img) => {
            const index = newSrcArray.findIndex(newItem => !img.src.includes('http') && newItem.alt === getFileNameFromPath(img.src));
            if (index > -1) {
              console.log('netSrc', newSrcArray[index].netSrc);
              img.setAttribute('src', newSrcArray[index].netSrc);
            }
          });
          // 更新编辑器内容
          editor.setContent(doc.body.innerHTML);
        }
      }

      function getFileNameFromPath(filePath) {
        // 使用 lastIndexOf 找到最后一个斜杠的位置
        const lastSlashIndex = filePath.lastIndexOf('/');
        // 如果没有找到斜杠，返回整个字符串
        if (lastSlashIndex === -1) {
          return filePath;
        }
        // 返回最后一个斜杠后面的字符串
        return filePath.substring(lastSlashIndex + 1);
      }

      // function findAllImageElementsWithLocalSource() {
      //   const editor = tinymce.get(id);
      //   if (editor) {
      //     // 获取编辑器的内容
      //     const content = editor.getContent();
      //     // 创建一个 DOMParser 实例
      //     const parser = new DOMParser();
      //     // 解析 HTML 字符串为文档
      //     const doc = parser.parseFromString(content, 'text/html');
      //     // 获取所有的 img 标签
      //     const imgElements = doc.querySelectorAll('img');

      //     return imgElements;
      //   }
      // }

      function extractImageDataFromRtf(rtfData) {
        if (!rtfData) {
          return [];
        }

        const regexPictureHeader = /{\\pict[\s\S]+?({\\\*\\blipuid\s?[\da-fA-F]+)[\s}]*/;
        const regexPicture = new RegExp('(?:(' + regexPictureHeader.source + '))([\\da-fA-F\\s]+)\\}', 'g');
        const images = rtfData.match(regexPicture);
        const result = [];

        if (images) {
          for (const image of images) {
            let imageType = false;

            if (image.includes('\\pngblip')) {
              imageType = 'image/png';
            } else if (image.includes('\\jpegblip')) {
              imageType = 'image/jpeg';
            }

            if (imageType) {
              result.push({
                hex: image.replace(regexPictureHeader, '').replace(/[^\da-fA-F]/g, ''),
                type: imageType,
                alt: altSources[result.length],//比较字符
              });
            }
          }
        }
        return result;
      }

      function _convertHexToBase64(hexString) {
        return btoa(hexString.match(/\w{2}/g).map(char => {
          return String.fromCharCode(parseInt(char, 16));
        }).join(''));
      }

    },

    /**
 * 处理上传资源地址
 */
    handleUploadPath(fileName) {
      let filePath = 'zpfaq' + this.getDateForPath();
      let uuid = generateUUID();
      filePath = filePath + uuid + '/' + fileName;
      return filePath;
    },
    /**
     * 根据当前时间拼接文件夹路径
     * @returns {string}
     */
    getDateForPath() {
      let date = new Date();
      let y = date.getFullYear();
      let m = date.getMonth() + 1;
      let month = m < 10 ? '0' + m : m;
      let d = date.getDate();
      let day = d < 10 ? '0' + d : d;
      //当用户学校id为空时
      return '/help/' + y + '/' + month + '/' + day + '/';
    }
  }
}
</script>